<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="ded2"><em><a id="page5"></a>Dedicated to</em></p>
<p class="ded"><em>Sgt. Eric M. Holke of the California Army National Guard</em></p>
<p class="ded">7/11/76–7/15/07</p>
<p class="ded"><em>Wish you were here.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Unincorporated_dedi-1.vue?652f1fc0